import { Switch } from 'antd'
import { useZoneAnalysisData } from 'features/libra/stepComponents/zoneAnalysis/ZoneAnalysisDataProvider'
import { useTicketAccess } from 'features/libra/ticket/TicketAccessContext'
import { FC, useMemo, useState } from 'react'
import styled from 'styled-components'

import { AssetModelZoneEditor } from './AssetModelZoneEditor'
import { DrawingBasedZoneEditor } from './DrawingBasedZoneEditor'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ModeToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.forecast.background2};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.forecast.border};
`

const ModeLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.forecast.secondaryText};
  font-weight: 500;
`

const ModeText = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: 600;
`

export const NiiZones: FC = () => {
  const { ticketTags } = useTicketAccess()
  const unitId = ticketTags.unit as string | undefined

  const {
    assetModelData: { assetModel, components },
  } = useZoneAnalysisData()

  // Check if asset model is available (for the rare 1% case)
  const hasAssetModel = useMemo(
    () => !!assetModel && components.length > 0,
    [assetModel, components]
  )

  // Default to drawing mode, allow toggle to asset model if available
  const [useAssetModelMode, setUseAssetModelMode] = useState(false)

  if (!unitId) {
    return (
      <Container>
        <div style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
          No unit specified for this ticket. Please ensure the ticket is tagged
          with a unit.
        </div>
      </Container>
    )
  }

  return (
    <Container>
      {/* Mode toggle - only show if asset model is available */}
      {hasAssetModel && (
        <ModeToggle>
          <ModeLabel>Zone Definition Mode:</ModeLabel>
          <Switch
            checked={useAssetModelMode}
            onChange={setUseAssetModelMode}
            checkedChildren='3D Model'
            unCheckedChildren='Drawings'
          />
          <ModeText>
            {useAssetModelMode ? '3D Asset Model' : 'Construction Drawings'}
          </ModeText>
        </ModeToggle>
      )}

      {/* Render appropriate editor based on mode */}
      {useAssetModelMode && hasAssetModel ? (
        <AssetModelZoneEditor />
      ) : (
        <DrawingBasedZoneEditor unitId={unitId} />
      )}
    </Container>
  )
}
